import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const Steak = () => {
  const products = [
    {
      id: 100,
      name: 'Original Flavour Steak',
      weight: '50g',
      description: 'Where it all began. Our signature 200-year-old family recipe, perfected with 100% grass-fed Australian beef. Classic seasoning, tender texture, and pure protein power. The original that started it all.',
      price: 9.95,
      image: 'https://customer-assets.emergentagent.com/job_3ad0df18-66ae-47af-92fb-c4edc5379868/artifacts/z7mhqks1_Original%20100%25%20Grass%20Fed%20Aussie%20Steak.jpg',
      protein: '25g',
      badge: 'Original',
      badgeColor: 'bg-blue-600',
      sku: 'OB-STEAK-ORIG-50G',
      coq10: true
    },
    {
      id: 101,
      name: 'Beer Snap Sticks',
      weight: '50g',
      description: 'The perfect beer companion. Crispy, savoury snap sticks made from 100% grass-fed Australian beef. Air-dried using our 200-year-old family recipe for that satisfying crunch.',
      price: 9.95,
      image: 'https://customer-assets.emergentagent.com/job_3ad0df18-66ae-47af-92fb-c4edc5379868/artifacts/v07lkps1_Beer%20Snap%20Sticks%20Original%20100%25%20Grass%20Fed%20Aussie%20Steak.jpg',
      protein: '25g',
      badge: 'Beer Match',
      badgeColor: 'bg-orange-500',
      sku: 'OB-STEAK-BEER-50G',
      coq10: true
    },
    {
      id: 102,
      name: 'Chilli Flavour Steak',
      weight: '50g',
      description: 'Bold heat meets premium beef. Our signature chilli blend infuses 100% grass-fed Australian steak with a fiery kick. Perfect for those who like it hot.',
      price: 9.95,
      image: 'https://customer-assets.emergentagent.com/job_3ad0df18-66ae-47af-92fb-c4edc5379868/artifacts/oqqktn7c_Chilli%20100%25%20Grass%20Fed%20Aussie%20Steak.jpg',
      protein: '25g',
      badge: 'Spicy',
      badgeColor: 'bg-red-600',
      sku: 'OB-STEAK-CHILLI-50G',
      coq10: true
    },
    {
      id: 103,
      name: 'Green Jalapeno Steak',
      weight: '50g',
      description: 'Fresh jalapeño heat meets tender grass-fed beef. A zesty, tangy twist on traditional air-dried steak with authentic green jalapeño flavour that builds with every bite.',
      price: 9.95,
      image: 'https://customer-assets.emergentagent.com/job_3ad0df18-66ae-47af-92fb-c4edc5379868/artifacts/aaeo5nou_Green%20Jalapeno%20100%25%20Grass%20Fed%20Aussie%20Steak.jpg',
      protein: '25g',
      badge: 'Tangy Heat',
      badgeColor: 'bg-green-600',
      sku: 'OB-STEAK-JALAP-50G',
      coq10: true
    },
    {
      id: 104,
      name: 'Honey Pineapple Bacon',
      weight: '50g',
      description: 'Sweet meets savoury in this unique creation. 100% Australian bacon air-dried with honey and pineapple for a tropical twist. A taste sensation unlike anything else.',
      price: 10.95,
      image: 'https://customer-assets.emergentagent.com/job_3ad0df18-66ae-47af-92fb-c4edc5379868/artifacts/osc8rhl0_Honey%20Pineapple%20100%25%20Aussie%20Bacon.jpg',
      protein: '25g',
      badge: 'Sweet & Savoury',
      badgeColor: 'bg-pink-500',
      sku: 'OB-BACON-HONEY-50G',
      coq10: false
    },
    {
      id: 105,
      name: 'Kids Original Steak',
      weight: '50g',
      description: 'The perfect lunchbox protein! Mild, tender air-dried steak made specially for little ones. 100% grass-fed Australian beef with our classic original seasoning. No artificial colours or preservatives.',
      price: 8.95,
      image: 'https://customer-assets.emergentagent.com/job_3ad0df18-66ae-47af-92fb-c4edc5379868/artifacts/zwoe6mur_Kids%20Version%20100%25%20Grass%20Fed%20Aussie%20Steak.jpg',
      protein: '25g',
      badge: 'Kids Favourite',
      badgeColor: 'bg-yellow-500',
      sku: 'OB-STEAK-KIDS-50G',
      coq10: true
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEO 
        title="Air Dried Steak Range - Coming Soon"
        description="Discover our premium air-dried steak range. 100% grass-fed Australian beef, crafted using traditional methods. Original, Beer Snap Sticks, Chilli, Green Jalapeno, Honey Pineapple Bacon & Kids favourites. Coming Soon!"
        keywords="air dried steak, grass fed beef, Australian steak snacks, beef jerky, beer snacks, protein snacks, kids protein, bacon snacks"
        url="/steak"
        image="https://customer-assets.emergentagent.com/job_3ad0df18-66ae-47af-92fb-c4edc5379868/artifacts/z7mhqks1_Original%20100%25%20Grass%20Fed%20Aussie%20Steak.jpg"
      />
      <Header />

      {/* Hero Section */}
      <section className="pt-20 pb-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-blue-50 to-white">
        <div className="max-w-7xl mx-auto text-center">
          <div className="mb-4 text-sm tracking-[0.3em] text-blue-700 font-semibold">
            NEW RANGE
          </div>
          <h1 className="text-5xl md:text-7xl font-bold mb-4">
            <span className="text-blue-600">AIR DRIED</span>
            <br />
            <span className="text-gray-900">STEAK</span>
          </h1>
          <p className="text-lg text-gray-700 mb-6 max-w-2xl mx-auto">
            100% Grass Fed Australian Beef. Premium cuts air-dried to perfection using our 200-year-old family recipe.
          </p>

          {/* Coming Soon Banner */}
          <div className="inline-block bg-blue-600 text-white px-8 py-4 rounded-full font-bold text-xl mb-6">
            COMING SOON
          </div>

          {/* Feature Badges */}
          <div className="flex flex-wrap justify-center gap-3 mb-8">
            <span className="bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-medium">
              100% Grass Fed
            </span>
            <span className="bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-medium">
              Australian Made
            </span>
            <span className="bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-medium">
              25g Protein
            </span>
            <span className="bg-purple-100 text-purple-800 px-4 py-2 rounded-full text-sm font-medium">
              CoQ10 Enriched
            </span>
          </div>

          <p className="text-gray-600 max-w-xl mx-auto">
            Be the first to know when our new Steak Range launches. Sign up to our newsletter or follow us for updates!
          </p>
        </div>
      </section>

      {/* Products Section - Preview Only */}
      <section id="steak-products" className="py-12 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Preview Our Range</h2>
            <p className="text-gray-600">Get a sneak peek at what's coming</p>
          </div>
          
          {/* Products Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {products.map(product => (
              <div 
                key={product.id} 
                className="bg-gray-50 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow flex flex-col relative"
                data-testid={`steak-product-card-${product.id}`}
              >
                {/* Coming Soon Overlay */}
                <div className="absolute inset-0 bg-black/5 z-20 pointer-events-none" />
                
                {/* Product Image */}
                <div className="aspect-square overflow-hidden relative">
                  <div className={`absolute top-4 right-4 ${product.badgeColor} text-white px-3 py-1 rounded-full text-sm font-semibold z-10`}>
                    {product.badge}
                  </div>
                  <div className="absolute top-4 left-4 bg-blue-600 text-white px-3 py-1 rounded-full text-xs font-semibold z-10">
                    Coming Soon
                  </div>
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className="w-full h-full object-cover"
                  />
                </div>

                {/* Product Info */}
                <div className="p-6 flex flex-col flex-grow">
                  <h3 className="text-xl font-bold mb-2">{product.name}</h3>
                  <p className="text-gray-600 text-sm mb-4 flex-grow">{product.description}</p>
                  
                  {/* Stats Row */}
                  <div className="flex justify-between px-2 mb-4">
                    <div className="text-center">
                      <div className="text-xl font-bold text-blue-600">{product.protein}</div>
                      <div className="text-xs text-gray-600">Protein</div>
                    </div>
                    <div className="text-center">
                      <div className="text-xl font-bold text-blue-600">{product.weight}</div>
                      <div className="text-xs text-gray-600">Weight</div>
                    </div>
                    {product.coq10 && (
                      <div className="text-center">
                        <div className="text-xl font-bold text-blue-600">CoQ10</div>
                        <div className="text-xs text-gray-600">Enriched</div>
                      </div>
                    )}
                  </div>

                  {/* Price and Coming Soon Button */}
                  <div className="flex items-center justify-between gap-4 mt-auto">
                    <div>
                      <span className="text-2xl font-bold text-gray-900">${product.price.toFixed(2)}</span>
                      <span className="text-sm text-gray-500 ml-1">inc. GST</span>
                    </div>
                    <div className="bg-gray-300 text-gray-600 px-5 py-2 rounded-md font-medium text-sm cursor-not-allowed">
                      Coming Soon
                    </div>
                  </div>
                  
                  <p className="text-xs text-gray-400 mt-3">SKU: {product.sku}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Australian Made Certification */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-blue-50">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-center gap-12">
            <a 
              href="https://australianmade.com.au" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex-shrink-0 p-6"
              title="Australian Made"
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_185b30bf-6e94-434b-8e3e-3ca910668034/artifacts/lq4m5jia_AMCL%20Logo.jpg" 
                alt="Australian Made Logo" 
                className="h-32 w-auto mix-blend-multiply"
              />
            </a>
            <div className="text-center md:text-left max-w-xl">
              <h3 className="text-2xl font-bold mb-3">100% Grass Fed Australian Beef</h3>
              <p className="text-gray-600">
                Our new Steak range continues our commitment to quality. Every product is made from 100% grass-fed 
                Australian beef, air-dried in Queensland using methods perfected over 200 years.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Info Cards */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center p-6 bg-blue-50 rounded-xl">
              <div className="text-3xl font-bold text-blue-600 mb-2">25g</div>
              <div className="font-bold mb-1">PROTEIN</div>
              <div className="text-sm text-gray-600">Per Pack</div>
            </div>
            <div className="text-center p-6 bg-blue-50 rounded-xl">
              <div className="text-3xl font-bold text-blue-600 mb-2">100%</div>
              <div className="font-bold mb-1">GRASS FED</div>
              <div className="text-sm text-gray-600">Australian Beef</div>
            </div>
            <div className="text-center p-6 bg-blue-50 rounded-xl">
              <div className="text-3xl font-bold text-blue-600 mb-2">$59+</div>
              <div className="font-bold mb-1">FREE SHIP</div>
              <div className="text-sm text-gray-600">Australia-Wide</div>
            </div>
            <div className="text-center p-6 bg-blue-50 rounded-xl">
              <div className="text-3xl font-bold text-blue-600 mb-2">200</div>
              <div className="font-bold mb-1">YEARS</div>
              <div className="text-sm text-gray-600">Family Recipe</div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Info */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-2xl mx-auto">
            <div className="bg-white p-8 rounded-2xl shadow-sm">
              <h3 className="font-bold text-xl mb-4 text-gray-900 text-center">Product Information</h3>
              <div className="space-y-3 text-gray-700 text-sm">
                <p><strong>Allergens:</strong> Contains beef. May contain traces of soy.</p>
                <p><strong>Storage:</strong> Cool, dry place. Refrigerate after opening.</p>
                <p><strong>Shelf Life:</strong> 12 months unopened</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Notify Me Section */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-blue-600 text-white">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">Want to Know When We Launch?</h2>
          <p className="text-blue-100 mb-8">
            Our Air Dried Steak range is coming soon! In the meantime, check out our original biltong range.
          </p>
          <a 
            href="/shop" 
            className="inline-block bg-white text-blue-600 px-8 py-3 rounded-full font-bold hover:bg-blue-50 transition-colors"
          >
            Shop Biltong Now
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Steak;
